import { CartItemProps } from '../../../Cart/types';
import { mapModifiersFromTransOrOrderItem } from '../../../Cart/utils/mapModifiersFromTransOrOrderItem';
import { OrderItemFieldsFragment } from '../../../graphql';
// import { castOrderModifier } from '../castOrderModifier';

export const castOrderItem = (
	orderItem: OrderItemFieldsFragment
): CartItemProps => {
	if (!orderItem.item.product) {
		throw new Error(
			"This orderItem can't be shown in the cart because it does not have a product."
		);
	}

	return {
		id: orderItem.id,
		modifiers: mapModifiersFromTransOrOrderItem(orderItem),
		price: (orderItem.price / 100).toFixed(2),
		product: orderItem.item.product,
		size: orderItem.item.size?.name
	};
};
